import React, { Component } from "react";

export default class Courses extends Component {
  render() {
    return <div>User courses will be placed here</div>;
  }
}
